import { queryOptions } from '@tanstack/react-query';
import API from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';

export const overdueInfoQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.overdueInfo,
    queryFn: API.credit.getOverdueInfo,
  });
